module.exports = __webpack_public_path__ + "static/img/hz-03.6887fa74.jpg";